<script setup>
import {computed, Fragment, h} from "vue";
import CodeBox from "@/components/global/CodeBox.vue";
import InlineCode from "@/components/global/InlineCode.vue";
import {useStore} from "vuex";

const props = defineProps({
  text: {
    type: [String, null],
    required: false,
    default: null,
  },
  websiteId: {
    type: Number,
    required: true,
  }
});

const store = useStore();
const cms = computed(() => store.getters['onsiteEditorInstallation/activeFilter']);

const codeBlockContent = computed(() =>
  `<script${['wordpress', 'elementor', 'woocommerce'].includes(cms.value) ? ' nowprocket nitro-exclude seraph-accel-crit="1"' : ''} data-cfasync="false" type="text/javascript" src="https://cdn.seoplatform.io/injector.js?websiteId=${props.websiteId}"><`+`/script>`
)

const Result = {
  setup() {
    return () => {
      const element = props.text.split(/\[\[(.*?)\]\]/g).map((match) => {
         switch (match) {
             case 'CODE_BLOCK':
                 return h(CodeBox, { code: codeBlockContent.value });
             case 'WEBSITE_ID':
                 return h(InlineCode, { code: props.websiteId });
             default:
                 return h('span', { innerHTML: match });
         }
      });
      return h(Fragment, null, element);
    }
  }
}
</script>

<template>
  <div>
    <Result />
  </div>
</template>
